import { createApiCall } from 'lib/base';

interface EditStaffAccountBody {}

const EDIT_STAFF_ACCOUNT = 'EDIT_STAFF_ACCOUNT';

export const editStaffAccountApi = createApiCall<
  EditStaffAccountBody & { id: string; payload: any }
>(EDIT_STAFF_ACCOUNT, ({ id, payload }) => ({
  endpoint: `api/admin/staff-accounts/${id}`,
  method: 'PATCH',
  body: payload,
}));

export default editStaffAccountApi;
